import styled from "styled-components";
import Form from "@/common/components/form/Form";
import { ClipSpinner } from "@/common/components/spinner";
import { PageContainr } from "@/common/elements";
import { KeyValueObj } from "@/common/types";
// import { loginUser } from "@/api";
// import useAuth from "@/hooks/useContexts";
// import { useState } from "react";
// import { Link, useNavigate, useSearchParams } from "react-router-dom";
// import { useNotification } from "@/common/components/Notifications/NotificationProvider";
// import { useApiCallHandling } from "@/hooks/useApiCallHandling";
// import { REGISTER_USER_URL } from "@/common/constants";
// import { Modal } from "@/common/components/modal";
// import { SuccessModal } from "@/pages/register/success-modal";

import { registerInvitedInput } from "./data";

const InvitedWrapper = styled(PageContainr)`
  width: 100%;

  .top {
    width: 100%;
    margin-top: 2rem;

    .logo-wrapper {
      width: 60px;
    }

    .welcome-message {
      margin-left: 1.75rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .sign-up {
        font-weight: 500;
        font-size: 3rem;
        line-height: 3.875rem;
        letter-spacing: 0.0009rem;
        font-family: "DM Sans";
        color: ${({ theme }) => theme.bg.primary};

        @media (max-width: ${({ theme }) => theme.screen.smallScreen}) {
          font-size: 2.2rem;
        }
      }
    }
  }

  .form {
    width: 100%;
    max-width: 76rem;
    margin-bottom: 2.25rem;
    margin-top: 1rem;
  }
`;

export interface IRegisterInvitedProps {}

export function RegisterInvited(_: IRegisterInvitedProps) {
  function processFormInputs(formData: KeyValueObj) {
    console.log(formData);
  }

  return (
    <InvitedWrapper>
      <div className="top flex-row">
        <div className="welcome-message">
          <h2 className="sign-up">Sign Up</h2>
        </div>
      </div>
      <div className="form">
        <Form
          formInputs={registerInvitedInput}
          loadingState={false}
          submitLabel="Sign Up"
          processInputs={processFormInputs}
          spinnerComponent={<ClipSpinner />}
          login={false}
          biControl={false}
          handleBack={undefined}
        />
      </div>
    </InvitedWrapper>
  );
}
